import { Component, OnInit, Input, OnDestroy, ViewChild, HostBinding, ElementRef, forwardRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import * as fromStore from '../store/reducers';
import * as workspaceActions from '../../pillar/workspace/store/actions';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as vocabularyActions from '../store/actions';
import * as actions from '../../pillar/dashboard/store/actions';
import { TileDescriptor } from '../../pillar/dashboard/services/TileDescriptor';
import { ModuleConfiguration } from '../vocabulary.module.config';
import { AddConceptVersionComponent } from "./add-concept-version.component"
import { ValueSetModel } from '../models/ValueSetModel';
import { StoreDataSource } from '../../core/services/StoreDataSource';
import { MatPaginator, MatSort, MatDialog } from "@angular/material";
import { SearchComponent } from '../../pillar/search/components/search.component';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { AddConceptVersionModel } from "../models/AddConceptVersionModel";
import { DeleteConceptVersionComponent } from './delete-concept-version.component';
import { TileComponent } from '../../pillar/dashboard/components/tile.component';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';
import { VocabularyService } from "../services/VocabularyService";
import { CurrentUserService } from '../../security/services/CurrentUserService';
import { AppConfigurationService } from '../../core/services/AppConfigurationService';


@Component({
  selector: 'brd-value-set-tile',
  providers: [{ provide: TileComponent, useExisting: forwardRef(() => ValueSetTileComponent) }],
  templateUrl: './value-set-tile.component.html',
  styleUrls: ['./value-set-tile.component.scss']
})
export class ValueSetTileComponent extends TileComponent implements OnInit, OnDestroy {

  constructor(private store: Store<any>,
              private router: Router,
              private actions$: Actions,
              private route: ActivatedRoute,
              private dialog: MatDialog,
              elementRef: ElementRef,
              private tileContainer: TileContainer,
              private vocabularyService: VocabularyService,
              private currentUserService: CurrentUserService,
              private appConfigurationService: AppConfigurationService) {
    super(elementRef);
    tileContainer.tileComponents.push(this);
  }

  static nextId = 0;

  _conceptCode: string;
  @Input()
  get conceptCode(): string | null {
    return this._conceptCode;
  }
  set conceptCode(val: string | null) {
    this._conceptCode = val;
  }
  _isDraft:boolean;
  @Input()
  get isDraft(): boolean | null {
    return this._isDraft;
  }

  set isDraft(val: boolean | null) {
    this._isDraft = val;
  }
  _conceptName: string;
  @Input()
  get conceptName(): string | null {
    return this._conceptName;
  }
  set conceptName(val: string | null) {
    if (this._conceptName !== val && this._conceptCode!== undefined) {
      this._conceptName = val;
      this.paginator.pageIndex = 0;
      this.getData();
    } else {
      this._conceptName = val;
    }
  }

  _codeSystemName: string;

  @Input()
  get codeSystemName(): string | null {
    return this._codeSystemName;
  }

  set codeSystemName(val: string | null) {
    this._codeSystemName = val;
  }

  @HostBinding()
  id = `brd-value-set-tile-${ValueSetTileComponent.nextId++}`;

  key: string;
  displayedColumns = ['conceptCode', 'conceptName', 'actions'];
  dataSource: StoreDataSource<ValueSetModel>;
  loading$: Observable<boolean>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  errors$: Observable<string[]>;
  accountActionLoading: Map<string, boolean> = new Map<string, boolean>();
  header:string;
  editPermission = 'VocabularyModule.CodeSystem:Edit';
  EditBaseVocabularyPermission = 'VocabularyModule.CodeSystem:EditBase';
  isMappedCodeSystem: boolean;

  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;
  @ViewChild(SearchComponent)
  search: SearchComponent;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;


  ngOnInit() {
    this.route.params.take(1).subscribe(p => {
      this.key = p['key'];
    });
    this.errors$ = this.store.select(fromStore.getConceptsForValueSetListErrors);
    this.loading$ = this.store.select(fromStore.getConceptsForValueSetListLoading);
    this.getData();

    this.vocabularyService.checkIfMappedCodeSystem(this.key)
      .takeUntil(this.destroyed$)
      .subscribe((isMapped) => {
        if(isMapped.model){
          this.isMappedCodeSystem = true;
        }
        else {
          this.isMappedCodeSystem = false;
        }
      });
  }
  ngOnDestroy(){
    this.destroyed$.next(true);
  }
  getData() {
    this.dataSource = new StoreDataSource<ValueSetModel>(
      this.destroyed$,
      this.paginator,
      this.store,
      this.store.select(fromStore.getConceptsForValueSetList),
      this.store.select(fromStore.getConceptsForValueSetListTotalCount),
      this.store.select(fromStore.getConceptsForValueSetListLoading),
      (p, s, search) => new vocabularyActions.GetConceptListAction(ModuleConfiguration.moduleName,
        ValueSetModel,
        {
          page: p.pageIndex,
          pageSize: p.pageSize,
          sort: s.active,
          sortDirection: s.direction,
          key: this.conceptCode,
          version: this.key,
          searchTerm: search.searchControl.value,
        }),
      this.sort,
      this.search
    );
    var result = this.conceptName.replace(/([A-Z])/g, " $1");
    this.header = result.charAt(0).toUpperCase() + result.slice(1);
  }

  selectItem(item: ValueSetModel) {
    this.router.navigateByUrl('concept-workspace/' + this.key +'?conceptCode=' + item.conceptCode);
  }

  showAdd(): void {
    this.dialog.open(AddConceptVersionComponent, {
      data: {
        code: '',
        name: '',
        valueSetCode: this.conceptCode,
        codeSystemVersionKey: this.key,
        isMappedCodeSystem: this.isMappedCodeSystem
      },
      panelClass: 'customized-dialog',
      width: '648px'
    });
  }

  delete(element: ValueSetModel) {
    this.dialog.open(DeleteConceptVersionComponent,
      {
        panelClass: 'customized-dialog',
        data:
        {
          name: element.conceptName,
          code: this.conceptCode,
          conceptVersionKey: element.conceptVersionKey,
          codeSystemVersionKey: this.key
        }
      });
  }

  hasAccessToCodeSystem(): boolean {
    var baseCodeSystems = this.appConfigurationService.configuration.baseCodeSystems.toLowerCase().split(",").map(Function.prototype.call, String.prototype.trim);
    return !baseCodeSystems.includes(this.codeSystemName.toLowerCase()) || (baseCodeSystems.includes(this.codeSystemName.toLowerCase()) && this.currentUserService.hasPermission(this.EditBaseVocabularyPermission));
  }
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/components/value-set-tile.component.ts